import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const DropdownArrow = ({ expanded, onClick }) => {
    const arrowStyles = {
        height: "0.75em",
        width: "0.75em",
    };
    const degrees = expanded ? "0" : "270";
    return (_jsx("div", { className: "inline-block mr-4", onClick: onClick, children: _jsx("svg", { className: "text-gray-600", style: arrowStyles, viewBox: "0 0 255 255", children: _jsx("g", { id: "arrow-drop-down", transform: `rotate(${degrees}, 128, 128)`, children: _jsx("polygon", { points: "0,63.75 127.5,191.25 255,63.75 \t\t" }) }) }) }));
};
export default DropdownArrow;
